var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"podcast","plural":"podcasts"},model:{value:(_vm.podcast),callback:function ($$v) {_vm.podcast=$$v},expression:"podcast"}})}
var staticRenderFns = []

export { render, staticRenderFns }